import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/auth/fire-auth/authentication.service';
import { SignOutModalComponent } from '../sign-out-modal/sign-out-modal.component';

@Component({
  selector: 'makaw-sign-out',
  templateUrl: './sign-out.component.html',
  styleUrls: ['./sign-out.component.scss'],
})
export class SignOutComponent implements OnInit {
  constructor(
    public dialog: MatDialog,
    private readonly _authenticationService: AuthenticationService,
    private readonly _router: Router
  ) {}

  ngOnInit() {
    const dialogRef = this.dialog.open(SignOutModalComponent, {
      width: '500px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.event === 'Exit') {
        this._authenticationService
          .logOut()
          .then(() => this.successLogOut())
          .catch((data) => this.errorLogOut(data));
      }
    });
  }
  successLogOut() {
    alert(`Session finalized`);
    this._router.navigate(['login']);
  }
  errorLogOut(data) {
    alert(`An error has occured!: ${data} `);
  }
}
